import { auth } from "@/plugins/firebase"
import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    userProfile: {},
    isLoggedIn: false
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val
    },

    clearUserProfile(state) {
      state.userProfile = {}
    },

    setLoggedIn(state) {
      state.isLoggedIn = true
    },

    setLoggedOut(state) {
      state.isLoggedIn = false
    }
  },
  actions: {
    async forgotPassword(_, form) {
      await auth.sendPasswordResetEmail(form.email)
    },

    login(_, form) {
      return auth.signInWithEmailAndPassword(form.email, form.password)
    },

    async sendVerificationEmail() {
      await auth.currentUser?.sendEmailVerification()
    },

    async reset(_, form) {
      await auth.sendPasswordResetEmail(form.email).catch(() => {
        return Promise.resolve
      })
    },

    async logout() {
      await auth.signOut()
    },

    async fetchUserProfile({ commit }, user) {
      commit("setUserProfile", {
        emailVerified: user.emailVerified
      })
    }
  },
  modules: {}
})
